export const actions = {
    artPerPageCards: "ART_PER_PAGE_CARDS",
    orderCards: "ORDER_CARDS"
}